// src/LandingPage.js
import React from "react";
import "./Landingpage.scss";
// import logo from "./assets/yerans-pufflava-logo.png"; // put your logo file here
const logo = "https://afag.imgix.net/pufflava/logo.jpg?w=1000&auto=format"
function App() {
  return (
    <div className="pufflava-page">
      <header className="hero" id="top">
        <div className="hero__logo-wrap">
          <img
            src={logo}
            alt="Yeran's Pufflava logo"
            className="hero__logo"
          />
        </div>
        <div className="hero__content">
          <p className="hero__tagline">
            Armenian &amp; Vegan Baklava – perfectly round, airy, and
            irresistibly puffy.
          </p>
          <h1 className="hero__title">Yeran&apos;s Pufflava</h1>
          <p className="hero__subtitle">
            Created by <strong>Patil V (she/her)</strong>, Yeran’s Pufflavas
            bring a completely unique twist on a beloved classic: her grandma’s
            vegan, pistachio-filled baklavas, lovingly renamed Pufflavas because
            they’re perfectly round, flaky, and full of nostalgic joy.
          </p>

          <div className="hero__actions">
            <a href="#signup" className="btn btn--primary">
              Join the Pufflava List
            </a>
            <a href="#catering" className="btn btn--ghost">
              Catering &amp; Events
            </a>
          </div>
        </div>
      </header>

      <main>
        <section className="section section--story">
          <div className="section__inner">
            <h2>Grandma&apos;s Recipe, Reimagined</h2>
            <p>
              Pufflavas started as a tray of homemade baklava in Patil&apos;s
              Los Angeles kitchen — a baked love letter to her grandma Yeran.
              Over time, those classic diamond slices evolved into playful,
              round little puffs: crisp, golden layers wrapped around a rich,
              pistachio filling, all completely vegan.
            </p>
            <p>
              Each Pufflava is rolled and baked in small batches, celebrating
              Armenian flavors while keeping things light, modern, and fun.
            </p>
          </div>
        </section>

        <section className="section section--what">
          <div className="section__inner section__inner--split">
            <div>
              <h2>What&apos;s a Pufflava?</h2>
              <ul className="list">
                <li>Vegan, pistachio-filled baklava puffs</li>
                <li>Perfectly round &amp; delightfully flaky</li>
                <li>Inspired by Armenian family recipes</li>
                <li>Handmade in Los Angeles</li>
              </ul>
            </div>
            <div className="callout">
              <h3>Small, shareable, unforgettable.</h3>
              <p>
                Perfect for dessert tables, coffee dates, office treats, and
                late-night sweet cravings.
              </p>
            </div>
          </div>
        </section>

        <section className="section section--catering" id="catering">
          <div className="section__inner section__inner--center">
            <h2>Catering &amp; Special Events</h2>
            <p>
              Planning a party, pop-up, or celebration? Pufflavas are made for
              gatherings — easy to serve, fun to eat, and absolutely
              photo-worthy.
            </p>
            <p className="section__highlight">
              <strong>Now taking catering orders.</strong> Call or text{" "}
              <a href="tel:18186369015" className="link-strong">
                818-636-9015
              </a>{" "}
              to chat with Patil about your event.
            </p>
          </div>
        </section>

        <section className="section section--signup" id="signup">
          <div className="section__inner section__inner--center">
            <h2>Get Pufflava Updates</h2>
            <p>
              Be the first to hear about drops, markets, pop-ups, and seasonal
              Pufflava flavors. No spam, just flaky goodness.
            </p>

            {/* Netlify form */}
            <form
              name="pufflava-email-list"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              className="signup-form"
            >
              {/* Hidden Netlify inputs */}
              <input type="hidden" name="form-name" value="pufflava-email-list" />
              <p className="hidden-field">
                <label>
                  Don’t fill this out if you’re human:
                  <input name="bot-field" />
                </label>
              </p>

              <div className="signup-form__row">
                <label className="signup-form__field">
                  <span className="signup-form__label">Name</span>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    required
                  />
                </label>
                <label className="signup-form__field">
                  <span className="signup-form__label">Email</span>
                  <input
                    type="email"
                    name="email"
                    placeholder="you@example.com"
                    required
                  />
                </label>
              </div>

              <label className="signup-form__field signup-form__field--full">
                <span className="signup-form__label">
                  What should we tell you about?
                </span>
                <textarea
                  name="message"
                  rows="3"
                  placeholder="Pop-ups, pre-orders, catering, flavor drops..."
                />
              </label>

              <button type="submit" className="btn btn--primary signup-form__submit">
                Join the Email List
              </button>
            </form>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer__inner">
          <p>Handmade in Los Angeles · Yeran&apos;s Pufflava by Patil V</p>
          <p className="footer__small">
            For catering, call/txt{" "}
            <a href="tel:18186369015" style={{color: 'darkblue'}} className="link-strong">
              818-636-9015
            </a>
            .
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;